enum Language {
	ES_AR = 'es-AR',
}

export default Language;

export const isValidLanguage = (value?: string) => new Set<any>(Object.values(Language)).has(value);
